import { ProductCard } from "@/components/product/product-card";
import type { Product } from "@/types";

export function ProductGrid({
  products,
  columns = 6
}: {
  products: Product[];
  columns?: 4 | 5 | 6;
}) {
  const gridClasses =
    columns === 4
      ? "grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4 sm:gap-3"
      : columns === 5
      ? "grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 sm:gap-3"
      : "grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 sm:gap-3";

  return (
    <div className={gridClasses}>
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
